import React from 'react';
import cx from 'classnames';

import styles from './index.less';

export const TypeEnum = {
  SUCCESS: 0,
  FAIL: 1,
  INFO: 2
};

const BaseToast = ({ type = TypeEnum.SUCCESS, text }) => {
  const iconTypeClassName = {
    [TypeEnum.SUCCESS]: styles.success,
    [TypeEnum.FAIL]: styles.fail,
    [TypeEnum.INFO]: styles.info
  };
  return (
    <div className={styles.toastRoot}>
      <div className={styles.ToastBg}>
        <div className={styles.bgLeft} />
        <div className={styles.bgConnect} />
        <div className={styles.bgRight} />
      </div>

      <div className={styles.content}>
        <div className={styles.text}>{text}</div>
        <div className={styles.line} />
        <div className={cx(styles.icon, iconTypeClassName[type])} />
      </div>
    </div>
  );
};

export default BaseToast;
